import { Box, Header, Text, addWithConfig } from '@rbilabs/universal-components';

import ActionButtonLink from 'components/action-button';
import { spacing } from 'styles/constants';

export const EmptyScreenWrapper = Box.withConfig({
  alignItems: 'center',
  flex: 1,
  marginTop: spacing.$3,
});

export const StyledActionButtonLink = addWithConfig(ActionButtonLink).withConfig({
  style: { marginTop: 16 },
  width: '$80',
});

export const HeaderText = Header.withConfig({
  variant: 'headerOne',
  margin: 0,
  fontSize: 'xl',
  lineHeight: 'md',
});

export const SubText = Text.withConfig({
  variant: 'copyOne',
  marginTop: '$4',
  marginX: '$8',
  marginBottom: '$0',
  fontSize: 'md',
  textAlign: 'center',
});

export const ImageWrapper = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  maxHeight: '$64',
  marginBottom: '$12',
});
